import { useQuery } from 'react-query';
import UserService from '../../services/user.service';
import { USER_QUERY_KEY } from '../../constants/query';

const useFetchUser = () => {
  return useQuery(USER_QUERY_KEY, UserService.getUser, {
    refetchOnWindowFocus: false,
  });
};

export default useFetchUser;
